import { render, staticRenderFns } from "./income.vue?vue&type=template&id=6a72702f&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72702f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a72702f')) {
      api.createRecord('6a72702f', component.options)
    } else {
      api.reload('6a72702f', component.options)
    }
    module.hot.accept("./income.vue?vue&type=template&id=6a72702f&scoped=true", function () {
      api.rerender('6a72702f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/income.vue"
export default component.exports